export default __webpack_public_path__ + "static/assets/12a52e7ae4a1310fa605f099e159a98c.png";